import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

const FALLBACK_SLUG = 'default'

const isTemplateActive = (vendor: any) =>
  !!(vendor?.template?.slug && vendor?.template?.isActive === true)

export function loadTemplate(vendor: any, path: string): ComponentType<any> {
  const slug = isTemplateActive(vendor) ? vendor.template.slug : FALLBACK_SLUG
  return dynamic(() =>
    import(`@/components/templates/${slug}/${path}`).catch(() =>
      import(`@/components/templates/${FALLBACK_SLUG}/${path}`)
    )
  ) as ComponentType<any>
}
